/**
 * ShortcutButtonBlock - styles
 */

import styled, { keyframes } from 'styled-components';
import { lighten } from 'polished';
import { H2, P } from 'components/Text/Text.styles';

interface StyledH2Props {
	hasPreamble?: boolean;
}

const svgSlide = keyframes`
	from {
		transform: translateX(0);
	}
	to {
		transform: translateX(4px);
	}
`;

interface LinkProps {
	backgroundColor?: string;
	color?: string;
	borderColor?: string;
}

export const StyledH2 = styled(H2)<StyledH2Props>`
	margin: 0 0 ${(props) => (props.hasPreamble ? '1rem' : '2rem')} 0;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding: 3rem 0;
`;

export const Link = styled.a<LinkProps>`
	text-decoration: none;
	border-radius: 999px;
	border: 1px solid
		${(props) => props.borderColor || props.backgroundColor || '#ffffff'};
	background-color: ${(props) => props.backgroundColor || '#ffffff'};
	color: ${(props) => props.color || '#ffffff'};
	padding: 0.5rem 1rem;
	transition: background-color 0.3s, border-color 0.3s;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	white-space: nowrap;
	outline: none;

	&:focus {
		outline: none;
	}

	&:hover {
		background-color: ${(props) => {
			if (props.borderColor && props.backgroundColor === '#ffffff') {
				return '#E6F2FE';
			}
			return lighten(0.2, props.backgroundColor || '#ffffff');
		}};
	}

	svg {
		flex-shrink: 0;
		transition: transform 0.3s ease-in-out;
	}

	&:hover svg {
		animation: ${svgSlide} 0.4s ease-in-out forwards;
	}

	@media (max-width: 768px) {
		max-width: 100%;
	}
`;

export const StyledP = styled(P)`
	margin: 0;
	font-weight: 500;
	font-style: normal;
	font-size: 1rem;
	@media (max-width: 768px) {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;

export const LinksContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
`;
